const formatDateToRU = (iso) => {
  if (!iso) return '-';
  try {
    const d = new Date(iso);
    if (isNaN(d)) return iso;
    return d.toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Warsaw'
    });
  } catch (e) {
    return iso;
  }
};

const safe = (v) => {
  if (v === undefined || v === null || v === '' ) return '-';
  // allow 0 and boolean true/false as values (false treated as '-')
  if (v === false) return '-';
  return v;
};

const formRequestMessage = (value) => {
  const { user_value, modal_list } = value;

  const formFields = modal_list.slice(3); // как у вас раньше

  const SKIP_TYPES = new Set(['p', 'li', 'h2', 'h1']);

  const fieldMessages = formFields.map((field, index) => {
    // пропускаем декоративные типы
    if (SKIP_TYPES.has(field.type)) return null;

    const rawUserVal = user_value[index];

    const fieldLabel = field.value ? String(field.value) : String(field.label || '');

    switch (field.type) {
      case 'select': {
        const options = field.value ? String(field.value).split(',') : [];
        let selected;
        if (Array.isArray(rawUserVal)) {
          selected = rawUserVal.map(i => (options[i] ?? '-')).join(', ');
        } else if (rawUserVal === undefined || rawUserVal === null || rawUserVal === '') {
          selected = '-';
        } else {
          const idx = Number(rawUserVal);
          selected = Number.isFinite(idx) ? (options[idx] ?? String(rawUserVal)) : String(rawUserVal);
        }
        return `✅ ${fieldLabel}: ${selected}`;
      }

      case 'radio': {
        const options = field.value ? String(field.value).split(',') : [];
        let sel = '-';
        if (Array.isArray(rawUserVal)) {
          sel = rawUserVal.map(i => options[i] ?? '-').join(', ');
        } else if (rawUserVal !== undefined && rawUserVal !== null && rawUserVal !== '') {
          const idx = Number(rawUserVal);
          sel = Number.isFinite(idx) ? (options[idx] ?? String(rawUserVal)) : String(rawUserVal);
        }
        return `✅ ${fieldLabel}: ${sel}`;
      }

      case 'checkbox': {
        const options = field.value ? String(field.value).split(',') : [];
        if (Array.isArray(rawUserVal)) {
          const vals = rawUserVal.map(i => options[i] ?? '-').join(', ');
          return `☑️ ${fieldLabel}: ${vals || '-'}`;
        } else if (typeof rawUserVal === 'number') {
          return `☑️ ${fieldLabel}: ${options[rawUserVal] ?? '-'}`;
        } else {
          return `☑️ ${fieldLabel}: ${safe(rawUserVal)}`;
        }
      }

      case 'datetime': {
        if (Array.isArray(rawUserVal)) {
          const list = rawUserVal.map(d => formatDateToRU(d)).join(' | ');
          return `🕒 ${fieldLabel}: ${list}`;
        } else {
          return `🕒 ${fieldLabel}: ${formatDateToRU(rawUserVal)}`;
        }
      }

      case 'file': {
        // ожидаем array of {name, url, ...} или array of urls
        if (Array.isArray(rawUserVal)) {
          const urls = rawUserVal.map(f => {
            if (!f) return '-';
            if (typeof f === 'string') return f;
            if (typeof f === 'object') return f.url || f.name || '-';
            return String(f);
          }).filter(u => u && u !== '-');
          return `📎 ${fieldLabel}: ${urls.length ? urls.join(', ') : '-'}`;
        } else if (rawUserVal && typeof rawUserVal === 'object') {
          return `📎 ${fieldLabel}: ${rawUserVal.url || '-'}`;
        } else {
          return `📎 ${fieldLabel}: ${safe(rawUserVal)}`;
        }
      }

      case 'textarea': {
        return `💬 ${fieldLabel}: ${safe(rawUserVal)}`;
      }

      case 'range': {
        return `🔢 ${fieldLabel}: ${safe(rawUserVal)}`;
      }

      case 'input':
      default: {
        const prefix = (field.type === 'input') ? '👤' : 'ℹ️';
        return `${prefix} ${fieldLabel}: ${safe(rawUserVal)}`;
      }
    }
  });


  const message = fieldMessages.filter(Boolean).join('\n');
  return message;
};


module.exports = {formRequestMessage};
